module.exports = __webpack_public_path__ + "img/vignettes-asso_0010_wake-up-cafe.9e4a7fe3.jpg";